import React from 'react'
import { confirmDialog } from 'primereact/confirmdialog'
import './maxOrderPerOrder.scss'
import { normalizeLineQty } from './maxOrderPerOrder'

export function getMinOrderQuantity(item) {
  if (!item) return null
  const m =
    item.minimumOrderQuantity ?? item.minimum_order_quantity
  if (m == null || m === '') return null
  const n = Number(m)
  if (!Number.isFinite(n) || n < 1) return null
  return Math.round(n)
}

export function isBelowMinOrderQuantity(item, qty) {
  const min = getMinOrderQuantity(item)
  if (min == null) return false
  const q = normalizeLineQty(qty)
  if (!Number.isFinite(q)) return false
  return q < min
}

export function MinOrderPerOrderMessage({ itemLabel, requestedQty, minQty }) {
  const label = itemLabel || 'This product'
  return (
    <div className='max-per-order-message'>
      <div className='max-per-order-message__symbol' aria-hidden='true'>
        <i className='pi pi-sliders-h' />
      </div>
      <div className='max-per-order-message__body'>
        <p className='max-per-order-message__line mb-0'>
          <span className='text-muted'>{label}</span>
        </p>
        <p className='max-per-order-message__line mt-2'>
          You entered <strong className='text-body'>{requestedQty}</strong> units. The
          minimum required per order for this item is{' '}
          <strong className='text-body'>{minQty}</strong>.
        </p>
        <p className='max-per-order-message__hint mb-0'>
          Enter at least {minQty} units, or adjust to {minQty} units to add this item to
          your order.
        </p>
      </div>
    </div>
  )
}

/**
 * @param {Object} params
 * @param {string} params.itemLabel
 * @param {number} params.requestedQty
 * @param {number} params.minQty
 * @param {() => void} params.onUseMin
 */
export function openMinOrderPerOrderDialog({
  itemLabel,
  requestedQty,
  minQty,
  onUseMin,
}) {
  confirmDialog({
    className: 'max-per-order-confirm-dialog',
    header: 'Minimum quantity for this product',
    message: (
      <MinOrderPerOrderMessage
        itemLabel={itemLabel}
        requestedQty={requestedQty}
        minQty={minQty}
      />
    ),
    acceptLabel: `Adjust to ${minQty} units`,
    rejectLabel: 'Go back and edit',
    acceptIcon: 'pi pi-check',
    rejectIcon: 'pi pi-arrow-left',
    rejectClassName: 'p-button-outlined p-button-secondary',
    style: { width: '100%', maxWidth: '26rem' },
    breakpoints: { '641px': '95vw' },
    dismissableMask: true,
    accept: onUseMin,
  })
}
